import React from 'react';
import { GlassButton } from './GlassUI';
import { FaGem, FaCrown, FaTimes, FaCheck, FaShieldAlt } from 'react-icons/fa';

interface WelcomeModalProps {
  onClose: () => void;
  onBuyPlans: () => void;
}

const FEATURES = [
  'Customer management with QR self-registration',
  'Order lifecycle tracking (5 stages)',
  'Repairs & Old Gold exchange',
  'Automatic database backups',
  'Secure encrypted access',
];

export const WelcomeModal: React.FC<WelcomeModalProps> = ({ onClose, onBuyPlans }) => {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-950/60 backdrop-blur-sm animate-fade-in" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden animate-scale-in">
        {/* Header */}
        <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 px-6 py-7 text-center relative">
          <button
            onClick={onClose}
            className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/10 text-white/80 hover:bg-white/20 flex items-center justify-center"
            aria-label="Close"
          >
            <FaTimes />
          </button>
          <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center shadow-lg shadow-amber-500/40 mb-3">
            <FaGem className="text-white text-2xl" />
          </div>
          <h2 className="text-2xl font-bold text-white">Welcome to ApniCRM!</h2>
          <p className="text-slate-300 text-sm mt-1">
            You're in the <span className="font-semibold text-amber-300">Demo Preview</span>
          </p>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-sm text-slate-600 mb-4 text-center">
            Explore everything the CRM can do for your jewelry business, then choose the
            right plan to go live.
          </p>

          <div className="space-y-2.5 mb-5">
            {FEATURES.map((f) => (
              <div key={f} className="flex items-start gap-2.5 text-sm text-slate-700">
                <FaCheck className="text-emerald-500 mt-0.5 flex-shrink-0" />
                <span>{f}</span>
              </div>
            ))}
            <div className="flex items-start gap-2.5 text-sm text-slate-700">
              <FaShieldAlt className="text-amber-500 mt-0.5 flex-shrink-0" />
              <span>Your data is safe — demo data can be cleared anytime, backups kept</span>
            </div>
          </div>

          <div className="flex flex-col gap-2.5">
            <GlassButton variant="gold" className="w-full py-3" onClick={onBuyPlans}>
              <FaCrown /> View Plans &amp; Upgrade
            </GlassButton>
            <GlassButton variant="secondary" className="w-full" onClick={onClose}>
              Start Exploring Demo
            </GlassButton>
          </div>

          <p className="text-[11px] text-slate-400 text-center mt-4">
            Yearly plans · Free demo · No card required
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;